import React from "react";
import { SelectSystems, SystemsList } from "./views";

export const SystemDetails: React.FC = () => {
  return (
    <React.Fragment>
      <SelectSystems />
      <SystemsList />
    </React.Fragment>
  );
};
